export default "__VITE_ASSET__4FIstwh8__";